/** Build dropdown sections from flat INSERT_ITEMS with `{ type: 'sep' }` dividers */
export const buildInsertSections = (items) => {
    const sections = []
    let bucket = []

    items.forEach((item) => {
        if (item.type === 'sep') {
            if (bucket.length > 0) {
                sections.push({ items: bucket })
                bucket = []
            }
        } else {
            bucket.push(item)
        }
    })

    if (bucket.length > 0) {
        sections.push({ items: bucket })
    }

    return sections
}
